import axios from 'axios';

const DEFAULT_LANGUAGE = 'pt';
const LANGUAGE_STORAGE_KEY = 'app.language';

const instance = axios.create();

instance.interceptors.request.use((config) => {
  const storedLanguage =
    typeof window !== 'undefined'
      ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
      : null;
  const documentLanguage =
    typeof document !== 'undefined' ? document.documentElement.lang : null;
  const normalizedLanguage =
    (storedLanguage || documentLanguage || DEFAULT_LANGUAGE)
      .toString()
      .slice(0, 2)
      .toLowerCase() || DEFAULT_LANGUAGE;

  config.headers = {
    ...(config.headers || {}),
    'Accept-Language': normalizedLanguage,
  };

  return config;
});

export default instance;
